import React, { useState } from "react";
import { Box, HStack, Button } from "@chakra-ui/react";
import Corrections from "./Corrections";
import Query from "./Query";

function LeftPanel(props) {
  const [view, setView] = useState("queries");

  return (
    <Box width="100%" minW="230px" height="100%" backgroundColor="#222222">
      <HStack
        px="4px"
        height="50px"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid #E8E2DF"
        backgroundColor="#323334"
        position={"sticky"}
        top={"0"}
        zIndex={10}
      >
        <Button
          variant="unstyled"
          style={{
            marginTop: "7px",
            color: view === "queries" ? "#FFFFFF" : "#CCCBD3",
            fontWeight: view === "queries" ? "600" : "400",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            fontFamily: "Roboto, sans-serif",
          }}
          fontWeight="400"
          width="60%"
          onClick={() => setView("queries")}
        >
          Queries
          <hr
            style={{
              marginTop: "14px",
              width: "60%",
              borderWidth: "1px",
              borderColor: view === "queries" ? "#FFFFFF" : "#323334",
            }}
          ></hr>
        </Button>
        <Button
          variant="unstyled"
          style={{
            marginTop: "7px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            color: view === "corrections" ? "#FFFFFF" : "#CCCBD3",
            fontWeight: view === "corrections" ? "600" : "400",
            fontFamily: "Roboto, sans-serif",
          }}
          fontWeight="400"
          width="80%"
          onClick={() => setView("corrections")}
        >
          Corrections
          <hr
            style={{
              marginTop: "14px",
              width: "60%",
              borderWidth: "1px",
              borderColor: view === "corrections" ? "#FFFFFF" : "#323334",
            }}
          ></hr>
        </Button>
      </HStack>
      {view === "corrections" ? (
        <Corrections corrections={props.corrections} ace={props.editorRef} />
      ) : (
        <Query ace={props.editorRef} />
      )}
    </Box>
  );
}

export default LeftPanel;
